import type { MarketCode } from '../../../@types/MarketCode';

export const getLatestTestDriveArticleURLSearchParams = (marketCode: MarketCode) => {
  const params = new URLSearchParams();
  switch (marketCode) {
    case 'NO':
      params.append('categories', encodeURIComponent('Biltester fra Broom TV2'));
      break;

    default:
      params.append('categories', encodeURIComponent('Välja bil'));
      break;
  }
  params.append('hits', '1');
  params.sort();
  return params;
};

export const getTestDriveArticleURLSearchParams = (marketCode: MarketCode) => {
  const params = new URLSearchParams();

  switch (marketCode) {
    case 'NO':
      params.append('categories', encodeURIComponent('Velg en bil'));
      break;

    default:
      params.append('categories', encodeURIComponent('Välja bil'));
      break;
  }
  params.append('offset', '1');
  params.append('hits', '6');
  params.sort();
  return params;
};

export const getArticlesURLSearchParams = (marketCode: MarketCode) => {
  const params = new URLSearchParams();

  switch (marketCode) {
    case 'NO':
      params.append('categories', encodeURIComponent('Kjøp en bil'));
      params.append('categories', encodeURIComponent('Selg bil'));
      params.append('categories', encodeURIComponent('Eier en bil'));
      break;

    default:
      params.append('categories', encodeURIComponent('Video'));
      params.append('categories', encodeURIComponent('Köpa bil'));
      params.append('categories', encodeURIComponent('Sälja bil'));
      params.append('categories', encodeURIComponent('Äga bil'));
      break;
  }
  params.append('hits', '6');
  params.sort();
  return params;
};
